import React from "react";

const Footer = () => {
  return (
    <footer
      className="mt-auto text-center py-3 text-muted"
      style={{ backgroundColor: "#EEEEEE" }}
    >
      <small className="fs-6">Sparky Tours | Copyright&copy; 2021</small>
    </footer>
  );
};

export default Footer;
